import { BaseService } from "./base.service";

export class IdentityService extends BaseService {
  async login(password: string) {
    const resp = await this.client.post("/identity/user/login", { password });
    console.log(resp);
    return resp.data;
  }
}
